import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 13,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 13,
    fontWeight: 500,
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  usageItem: {
    fontSize: 12,
    fontWeight: 400,
    listStyle: 'none',
    display: 'inline-block',
  },
}));